export default __webpack_public_path__ + "static/graph-compare-f6fb55ea2b6b55fb3f9653fcebba94e7.webp";